import { WorkOrderDto } from '@zopup/zop-types';

const qty = (value: number, unit: string) => ({ value, unit });

const daysFromNow = (days: number): Date => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
};

export const generateMockWorkOrders = (): WorkOrderDto[] => [
    {
        id: 'wo-gearbox-001',
        number: 'WO-2026-0001',
        type: 'Manufacturing',
        subjectType: 'Item',
        subjectId: 'item-gearbox-assy',
        targetQuantity: qty(25, 'EA'),
        scope: 'Batch build for Q1 replenishment',
        status: 'InProgress',
        workDefinitionId: 'bom-gear-01-r5',
        plannedStart: daysFromNow(-3),
        plannedEnd: daysFromNow(4),
        actualStart: daysFromNow(-2),
        plannedCost: 18500,
        actualCost: 9200,
        currency: 'USD',
        version: 3,
    },
    {
        id: 'wo-ctrl-panel-002',
        number: 'WO-2026-0002',
        type: 'Manufacturing',
        subjectType: 'Item',
        subjectId: 'item-ctrl-panel',
        targetQuantity: qty(10, 'EA'),
        scope: 'Pilot run for new enclosure revision',
        status: 'Released',
        workDefinitionId: 'bom-ctrl-panel-r2',
        plannedStart: daysFromNow(1),
        plannedEnd: daysFromNow(6),
        plannedCost: 6400,
        currency: 'USD',
        version: 2,
    },
    {
        id: 'wo-conveyor-003',
        number: 'WO-2026-0003',
        type: 'Assembly',
        subjectType: 'Item',
        subjectId: 'item-conveyor-unit',
        targetQuantity: qty(4, 'EA'),
        scope: 'Customer order #SO-4021',
        status: 'Planned',
        workDefinitionId: 'bom-conveyor-belt-r1',
        plannedStart: daysFromNow(3),
        plannedEnd: daysFromNow(10),
        plannedCost: 5200,
        currency: 'USD',
        version: 1,
    },
    {
        id: 'wo-hyd-cylinder-004',
        number: 'WO-2026-0004',
        type: 'Manufacturing',
        subjectType: 'Item',
        subjectId: 'item-hyd-cylinder',
        targetQuantity: qty(15, 'EA'),
        scope: '',
        status: 'Draft',
        workDefinitionId: 'bom-hyd-cylinder-r1',
        version: 1,
    },
    {
        id: 'wo-steel-frame-005',
        number: 'WO-2026-0005',
        type: 'Manufacturing',
        subjectType: 'Item',
        subjectId: 'item-steel-frame-assy',
        targetQuantity: qty(50, 'EA'),
        scope: 'Warehouse restock',
        status: 'Completed',
        workDefinitionId: 'bom-steel-frame-r1',
        plannedStart: daysFromNow(-14),
        plannedEnd: daysFromNow(-7),
        actualStart: daysFromNow(-14),
        actualEnd: daysFromNow(-6),
        plannedCost: 12000,
        actualCost: 11750,
        currency: 'USD',
        version: 4,
    },
    {
        id: 'wo-packaging-006',
        number: 'WO-2026-0006',
        type: 'Manufacturing',
        subjectType: 'Item',
        subjectId: 'item-packaging-box',
        targetQuantity: qty(500, 'EA'),
        scope: 'Bulk packaging stock',
        status: 'Closed',
        workDefinitionId: 'bom-packaging-box-r1',
        plannedStart: daysFromNow(-30),
        plannedEnd: daysFromNow(-25),
        actualStart: daysFromNow(-30),
        actualEnd: daysFromNow(-24),
        plannedCost: 2100,
        actualCost: 2050,
        currency: 'USD',
        version: 3,
    },
    {
        id: 'wo-weld-fixture-007',
        number: 'WO-2026-0007',
        type: 'Manufacturing',
        subjectType: 'Item',
        subjectId: 'item-weld-fixture',
        targetQuantity: qty(6, 'EA'),
        scope: 'Tooling refresh - on hold pending parts',
        status: 'OnHold',
        workDefinitionId: 'bom-weld-fixture-r1',
        plannedStart: daysFromNow(-5),
        plannedEnd: daysFromNow(2),
        actualStart: daysFromNow(-5),
        plannedCost: 4300,
        actualCost: 1900,
        currency: 'USD',
        version: 2,
    },
    {
        id: 'wo-gearbox-008',
        number: 'WO-2026-0008',
        type: 'Rework',
        subjectType: 'Item',
        subjectId: 'item-gearbox-assy',
        targetQuantity: qty(3, 'EA'),
        scope: 'Rework units failing final inspection',
        status: 'Cancelled',
        workDefinitionId: 'bom-gear-01-r4',
        version: 1,
    },
];
